import styled from "styled-components";

const StyledContactGrid = styled.div`
  display: grid;
  grid-column-gap: 3rem;
  grid-row-gap: 3rem;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto;

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }

  /****************************/
  /*   Contact Form Wrapper   */
  /****************************/

  .contact_form-wrapper {
    margin-bottom: 0;
    padding: 1rem 0.5rem;
    border-style: solid;
    border-width: 1px;
    border-color: rgba(0, 0, 0, 0.13);
    border-radius: 0.5rem;
    background-color: #f5f7fa;
  }

  @media screen and (max-width: 479px) {
    .contact_form-wrapper {
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }
  }

  /****************************/
  /*     Contact Wrapper      */
  /****************************/

  .contact_wrapper {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    border-style: solid;
    border-width: 1px;
    border-color: rgba(0, 0, 0, 0.13);
    border-radius: 0.5rem;
    background-color: #f5f7fa;
  }

  .contact_wrapper {
    justify-self: center;
  }

  .contact_info {
    display: grid;
    padding-top: 1rem;
    padding-bottom: 1rem;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-gap: 16px;
    grid-template-columns: 5rem 1fr;
    grid-template-rows: auto;
  }

  .contact_link-block {
    text-decoration: none;
  }

  .contact_text-block {
    display: flex;
    flex-direction: column;
    justify-self: start;
  }

  .contact_title {
    font-size: 1.25rem;
    line-height: 1;
  }

  .contact_title-info {
    font-size: 0.95rem;
  }

  .contact_solid-icon {
    background-image: linear-gradient(180deg, #007bff, #c7c70d);
    font-family: 'Font Awesome 6 Free', sans-serif;
    font-size: 4rem;
    line-height: 1;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .contact_solid-icon:hover {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#c7c70d), to(#007bff));
    background-image: linear-gradient(180deg, #c7c70d, #007bff);
  }

  .contact-brand-icon {
    background-image: linear-gradient(180deg, #007bff, #c7c70d);
    font-family: 'Font Awesome 6 Brands', sans-serif;
    font-size: 4rem;
    line-height: 1;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .contact-brand-icon:hover {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#c7c70d), to(#007bff));
    background-image: linear-gradient(180deg, #c7c70d, #007bff);
  }

`

export default StyledContactGrid;